export function isHistoryState(val: unknown): val is { key: string; url: string } {
  if (!val) return false;
  if (typeof val !== "object") return false;
  if (!("key" in val)) return false;
  if (!("url" in val)) return false;
  return true;
}
